export default {
    AUCTION: 'Auction',
    AUCTION_BIN: 'AuctionBin',
    PURE_BIN: 'PureBin',
    SHOP_ITEM: 'ShopItem'
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/constants/item-types.js